import React from 'react'
import TabsMUI from '@material-ui/core/Tabs'

function Tabs(props) {
  const {classes, ...otherProps} = props

  return (
    <TabsMUI
      classes={{
        root: `audit__tabs ${classes?.root ? ` ${classes.root}` : ''}`,
        indicator: 'audit__tabs--selected',
      }}
      {...otherProps}
    />
  )
}

Tabs.displayName = 'Tabs'

export default Tabs
